<template>
  <div class="select-material-type">
    <div class="type-title">请选择资料递交方式</div>
    <div class="type-content">
      <div class="type-item-box" :class="{'active': innerOffline === 0}" @click="selectType(0)">
        <div class="icon-recommend"></div>
        <div class="item-title">在线上传</div>
        <div class="item-desc">
          <div class="desc-item">可转发直客填写资料</div>
        </div>
      </div>
      <div class="type-item-box" :class="{'active': innerOffline === 1, 'not-choice': !isSupportOffline}" @click="isSupportOffline ? selectType(1) : () => {}">
        <div class="item-not-choice-prompt" v-if="!isSupportOffline">该商品不支持</div>
        <div class="item-title">线下邮寄</div>
        <div class="item-desc">
          <div class="desc-item">顺丰上门取件</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    offline: Number,
    isSupportOffline: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    innerOffline: {
      get() {
        return this.offline;
      },
      set(value) {
        this.$emit('update:offline', value);
      },
    },
  },
  created() {},
  methods: {
    // 选择方式
    selectType(offline) {
      this.innerOffline = offline;
    },
  },
};
</script>

<style lang="less" scoped>
.select-material-type{
  .type-title{
    color: #2F333D;
    font-size: 16px;
    font-weight: 600;
  }
  .type-content{
    margin-top: 16px;
    display: flex;
    .type-item-box{
      flex: 1;
      min-height: 72px;
      padding: 16px;
      border-radius: 2px;
      border: 1px solid #DEE2E6;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      margin-right: 16px;
      &:last-child{
        margin-right: 0;
      }
      .icon-recommend{
        width: 91px;
        height: 72px;
        background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/created-order/icon-recommend.png) no-repeat center / 100% 100%;
        position: absolute;
        left: -12px;
        top: -12px;
      }
      .item-title{
        font-size: 16px;
        font-weight: 600;
        color: #2F333D;
      }
      .item-desc{
        margin-top: 8px;
        .desc-item{
          font-size: 14px;
          color: #91999F;
        }
      }
      .item-not-choice-prompt{
        color: #91999F;
        padding: 0 7px;
        height: 20px;
        font-size:12px;
        line-height: 1;
        border-radius: 4px 0px 4px 0px;
        background: #E9EEF2;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
      }
      &.active{
        border-color: #599FFF;
        background: #F3F8FF;
        .item-title{
          color: #599FFF;
        }
        .item-desc{
          .desc-item{
            color: #599FFF;
          }
        }
        &::before{
          content: "";
          width: 32px;
          height: 32px;
          background: url('../../../../assets/imgs/order/icon-勾选@2x.png') no-repeat center / 100% 100%;
          position: absolute;
          right: -1px;
          bottom: -1px;
        }
      }
      &.not-choice {
        cursor: not-allowed;
        background-color: #FAFBFC;
        .item-title{
          color: #C9CDD1;
        }
        .item-desc{
          .desc-item{
            color: #C9CDD1;
          }
        }
      }

    }
  }
  
  
}

</style>



// WEBPACK FOOTER //
// src/components/add-order/created-order/components/select-online-or-offline-inner.vue